import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from 'Components/Button';
import SmallButton from 'Components/Button/SmallButton';

import './OptionBoxPopupFooter.scss';

const OptionBoxPopupFooter = ({
  applyDisabled,
  applyText,
  cancelText,
  extraClass,
  id,
  onApply,
  onCancel,
  tertiaryAction,
  tertiaryClass,
  tertiaryText,
  whiteLabelingFlag,
}) => {
  const wrapperClass = classnames('option-box-content-footer', {
    [extraClass]: extraClass,
  });

  return (
    <div className={wrapperClass}>
      <div className="option-box-content-footer__footer-left">
        {
          tertiaryAction && tertiaryText.length > 0 && (
            <Button
              action={tertiaryAction}
              extraClass={tertiaryClass}
              category="small link-inline"
            >
              {tertiaryText}
            </Button>
          )
        }
      </div>
      <div className="option-box-content-footer__footer-right">
        <Button
          id={`${id}_columnManager_btn_cancel`}
          action={onCancel}
          category="small link-inline"
          extraClass={whiteLabelingFlag? '-secondary-action-HPYMre' :extraClass=="HPY"?"secondary-action-HPY":"secondary-action"}
        >
          {cancelText}
        </Button>
        <SmallButton
          id={`${id}_columnManager_btn_apply`}
          action={onApply}
          disabled={applyDisabled}
          //extraClass="primary-action"  {{extraClass}=='-HPY'?{extraClass}:"primary-action"}
          extraClass={whiteLabelingFlag? '-HPYHoverSmallButton' : extraClass=="HPY"?" -HPY ":"primary-action"}
        >
          {applyText}
        </SmallButton>
      </div>
    </div>
  );
};

OptionBoxPopupFooter.propTypes = {
  applyDisabled: PropTypes.bool,
  applyText: PropTypes.string,
  cancelText: PropTypes.string,
  extraClass: PropTypes.string,
  id: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  tertiaryAction: PropTypes.func,
  tertiaryText: PropTypes.string,
};

OptionBoxPopupFooter.defaultProps = {
  applyDisabled: false,
  applyText: 'Export',
  cancelText: 'Cancel',
  extraClass: '',
  id: '',
  tertiaryAction: null,
  tertiaryText: '',
};

export default OptionBoxPopupFooter;
